import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import {
  jumpToWallet,
  closeWebview,
} from 'src/helper/webviewFun'
import config from 'src/core/config'
import VConsole from 'src/helper/vconsole'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    // this.storeGameBaisun = this.props.store.register('app/game-baisun')
  }



  state = {
    loading: false,
    lang: langM.ar,
    language: '2',
    // GameURL: '',
    uid: 0,
    accesstoken: '',
  }

  async componentWillMount() {
    let { language, uid, accesstoken, gid, app } = this.getQuery()
    language = await getlang(language)
    console.log("language", language)

    let langObj = {
      'tr': '10',
      'en': '2',
      'ar': '7',
      'zh': '2',
      'ru': '13',
      'id': '3',
      'pt': '9',
      'uz': '23',
      'fa': '19',
      'ur': '11'
    }

    this.setState({
      lang: setlang(language, langM),
      language: langObj[language] || '2',
      uid: uid,
      gid: gid,
      accesstoken: accesstoken,
      app: app || 'baishun'
      // GameURL: GameURL
    })
    // await this.storeGameBaisun.GetUserInfoWeb(uid)
    await this.RunOnStart(uid)
    const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat'
    if (!isProd) {
      new VConsole()
    }
  }

  //初始化
  RunOnStart = async (uid) => {
  }

  getConfig = (jsCallback) => {
    console.log("收到游戏getConfig")
    //TODO 业务侧根据对接文档,填充相应数据
    let { uid, accesstoken, gid, language, app } = this.state

    let appId = 2516905513

    if (app=='baishun') {
      appId = 2516905513
    }
    if (app=='baishun_ar') {
      appId = 8827466951
    }
    if (app=='baishun_en') {
      appId = 1839212194
    }   
    if (app=='baishun_hoby_lv1') {
      appId = 6785877743
    }
    if (app=='baishun_hoby_lv2') {
      appId = 3800519592
    }
    if (app=='baishun_hoby_ar_lv1') {
      appId = 1916276841
    }
    if (app=='baishun_hoby_ar_lv2') {
      appId = 9339305544
    }
    if (app=='baishun_ny') {
      appId = 2468667751
    }
    if (app=='baishun_cis') {
      appId = 4288722362
      console.log("正式",appId)
    }

    var getConfigData = {
      appChannel: "hoby",
      appId: appId,
      userId: uid + '',
      code: accesstoken,
      roomId: gid + '',
      gameMode: "2",
      language: language,
      gameConfig: {
        sceneMode: 0,
        currencyIcon: "https://img.chatie.live/app/source/gold3.png"
      },
      gsp: 201 //游戏正式服务器节点：101-新加坡(阿里云)，201-迪拜AWS，301-硅谷(阿里云)，401-法兰克福(阿里云)
    }

    const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat'
    console.log(11111111, process.env.NODE_ENV, isProd)
    if (!isProd) {
      appId = 1459840848
      if (app=='baishun') {
        appId = 1459840848
      }
      if (app=='baishun_ar') {
        appId = 5250758649
      }
      if (app=='baishun_en') {
        appId = 6936838564
      }      
      if (app=='baishun_hoby_lv1') {
        appId = 8677045092
      }
      if (app=='baishun_hoby_lv2') {
        appId = 9168587976
      }
      if (app=='baishun_hoby_ar_lv1') {
        appId = 8640231470
      }
      if (app=='baishun_hoby_ar_lv2') {
        appId = 9559897269
      }
      if (app=='baishun_ny') {
        appId = 6508532427
      }
      if (app=='baishun_cis') {
        appId = 1661134436
        console.log("测试",appId)
      }
      getConfigData.gsp = 101
      getConfigData.appId = appId
      // console.log('app', app)
      // console.log('appId', getConfigData.appId)
    }
    // console.log('app', app)
    console.log('getConfigData', getConfigData)
    this.sendDataToGame(jsCallback, getConfigData)
  }

  sendDataToGame = (jsMethods, c) => {
    var data = {
      jsMethods: jsMethods,
      jsData: JSON.stringify(c)
    }
    const iFrame = document.getElementById('iframe');
    iFrame.contentWindow.postMessage(data, '*');
    console.log("sendDataToGame", data)
  }

  componentDidMount() {
    // setTimeout(() => {
    const iFrame = document.getElementById('iframe');
    iFrame.onload = () => {
      // 阻止浏览器默认行为，允许文件拖入到 dropzone 区域
      window.addEventListener('message', (e) => {
        console.log("addEventListener 收到消息", e)
        if (e.data) {
          var data = JSON.parse(e.data);
          var jsCallback = data.jsCallback;
          if (jsCallback.includes("getConfig")) {
            this.getConfig(jsCallback)
          } else if (jsCallback.includes("destroy")) {
            console.log("收到游戏destroy")
            closeWebview()
            //TODO 业务侧销毁iframe
          } else if (jsCallback.includes("gameRecharge")) {
            console.log("收到游戏gameRecharge")
            jumpToWallet()
            //TODO 业务侧弹窗商城
          }
          else if (jsCallback.includes("gameLoaded")) {
            console.log("收到游戏gameLoaded")
            //TODO 业务侧移除加载动画
          } else if (jsCallback.includes("walletUpdate")) {
            jumpToWallet()
            //TODO 业务侧移除加载动画
          }
        }
      })
    }
    // }, 0)
  }

  getQuery() {
    // 获取 hash 中的查询字符串部分
    let hash = window.location.hash
    let queryString = hash.includes('?') ? hash.split('?')[1] : ''

    // 将 URL 编码中的 \u0026 替换为 &
    let cleanQuery = decodeURIComponent(queryString).replace(/\\u0026/g, '&')

    // 解析参数
    let params = new URLSearchParams(cleanQuery)

    // 提取所需参数
    let uid = params.get('uid')
    let accesstoken = params.get('accesstoken')
    let app = params.get('app')
    let gid = params.get('gid')
    let GameURL = params.get('GameURL')
    let lang = params.get('lang') || "en"

    // 输出结果
    console.log('uid:', uid)
    console.log('accesstoken:', accesstoken)
    console.log('app:', app)
    console.log('gid:', gid)
    console.log('GameURL:', GameURL)
    console.log('lang:', lang)

    return {
      uid: uid,
      accesstoken: accesstoken,
      app: app,
      gid: gid,
      GameURL: GameURL,
      lang: lang
    }
  }

  render() {
    let { GameURL } = this.getQuery()
    return (
      <div className={`game1`}>
        {GameURL && GameURL != '' && <iframe
          className="app-games-iframe"
          id='iframe'
          src={`${GameURL}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-baisun/index.js